import React from 'react';
import { Button, Icon, Form, List } from 'tabler-react';
import toast from 'cogo-toast';
import i18n from '../../shared/i18n';

class TrialCards extends React.Component {
  handleCopy = () => {
    document.querySelector('[name="share-text"]').select();
    document.execCommand('copy');
  };

  handleCopyLink = () => {
    document.querySelector('[name="share-link"]').select();
    document.execCommand('copy');
    toast.success(i18n.t('dash-tip-copyok'));
  };

  render() {
    const { shareText, referLink } = this.props;
    return (
      <div className="malus-share">
        <Form.Group
          label={
            <Form.Label>
              {i18n.t('dash-share-textcopy')}
              <Button
                className="copy-btn"
                color="secondary"
                size="sm"
                pill
                onClick={this.handleCopy}>
                <Icon name="copy" />
                {i18n.t('dash-btn-copy')}
              </Button>
            </Form.Label>
          }>
          <Form.Textarea
            rows={4}
            name="share-text"
            value={shareText}
            readOnly
          />
        </Form.Group>
        <Button.List className="malus-social-group" align="left">
          <Button
            social="facebook"
            RootComponent="a"
            href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
              referLink,
            )}`}
            target="_blank">
            {i18n.t('dash-prefix-shareto')} Facebook
          </Button>
          <Button
            social="twitter"
            RootComponent="a"
            href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(
              shareText,
            )}`}
            target="_blank">
            {i18n.t('dash-prefix-shareto')} Twitter
          </Button>
        </Button.List>
        <Form.Group label={i18n.t('dash-card-ruletitle')}>
          <List>
            <List.Item>{i18n.t('dash-card-rule1')}</List.Item>
            <List.Item>
              {i18n.t('dash-card-rule2')}
            </List.Item>
          </List>
        </Form.Group>
      </div>
    );
  }
}

export default TrialCards;
